import "./svg/kjott.svg"

export default {
    name: "kjott",
    viewBox: "124 68",
}
